import React, { Component } from 'react';
import { Layout, Card, BlockStack, Button, Popover, ActionList, Thumbnail, Link, Text, SkeletonDisplayText, SkeletonBodyText } from '@shopify/polaris';
import { withRouter } from 'react-router-dom';
import { reqGetShopifyPrimary, resSaveShopifyPrimary } from '../../../api';
import { connect } from 'react-redux'
import { setPageLoading } from '../../../redux/actions/getAppPageData';
import { setPageData } from '../../../redux/actions/getAppPageData';
import './index.css';
import Language from '../../../i18n/Language';
const t = Language;

class FunctionIntegration extends Component {
  state = {
    loading: true,
    loadingPage: true,
    active: false,
    btnText: '',
    saveBtnStatus: false,
    selectActiveObj: {
      "Judge Me": false,
      "TT Ali Reviews": false,
      "Loox": false,
      "Shopify Product Review": false,
      "Reviews By Ryviu": false,
      "FireApps Review": false,
      "Rivyo": false,
      "Okendo": false,
      "LAI Product Reviews": false,
      "Fera Product Reviews": false,
      "Areviewsapp - video reviews": false,
      "Stamped Product Reviews & UGC": false,
    }, // 高亮
    showToast: false,  //弹窗显示
    showToastText: '',  //弹窗文字
    showToastIserror: false, //弹窗是否错误
    defaultData: {
      'Judge Me': {
        'img': '/integrationIcon/JudgeMe.png',
        'text': 'Judge Me',
        'content': 'Product reviews with photos & videos for social proof & SEO',
        'alt': 'JudgeMe.png',
      },
      'TT Ali Reviews': {
        'img': '/integrationIcon/TTAliReviews.png',
        'text': 'TT Ali Reviews',
        'content': 'Faster Aliexpress review importer for Dsers Oberlo and Zendrop',
        'alt': 'TTAliReviews.png',
      },
      'Loox': {
        'img': '/integrationIcon/Loox.png',
        'text': 'Loox',
        'content': 'Social Proof Marketing: Product Reviews, Referrals and Upsell',
        'alt': 'Loox.png',
      },
      'Shopify Product Review': {
        'img': '/integrationIcon/ProductReview.png',
        'text': 'Shopify Product Review',
        'content': 'Allow customers to leave product reviews on your store',
        'alt': 'ProductReview.png',
      },
      'Reviews By Ryviu': {
        'img': '/integrationIcon/ReviewsRyviu.png',
        'text': 'Reviews By Ryviu',
        'content': 'Collect customer reviews, import AliExpress, Amazon reviews',
        'alt': 'ReviewsRyviu.png',
      },
      'FireApps Review': {
        'img': '/integrationIcon/FireApps.png',
        'text': 'Kudosi',
        'content': 'Import photos & video reviews from AliExpress, Amazon',
        'alt': 'FireApps.png',
      },
      'Rivyo': {
        'img': '/integrationIcon/Rivyo.png',
        'text': 'Rivyo Product Reviews',
        'content': 'Product Reviews, Photos, Amazon/Aliexpress Reviews, Q&A, UGC',
        'alt': 'Rivyo.png',
      },
      'Okendo': {
        'img': '/integrationIcon/Okendo.png',
        'text': 'Okendo Reviews',
        'content': 'Build drive conversions with authentic customer ratings, reviews.',
        'alt': 'Okendo.png',
      },
      'LAI Product Reviews': {
        'img': '/integrationIcon/Smartify.png',
        'text': 'LAI Product Reviews',
        'content': 'Collect & import reviews from Ali, DSers, Amazon, and customers',
        'alt': 'Smartify.png',
      },
      'Fera Product Reviews': {
        'img': '/integrationIcon/Fera.jpg',
        'text': 'Fera Product Reviews',
        'content': 'Collect photo, video, and text reviews and show them beautifully.',
        'alt': 'Fera.jpg',
      },
      'Areviewsapp - video reviews': {
        'img': '/integrationIcon/areviews.jpg',
        'text': 'Areviewsapp - video reviews',
        'content': 'import images & video reviews from amazon,shopee,aliexpress... and more in few clicks',
        'alt': 'areviews.jpg',
      },
      'Stamped Product Reviews & UGC': {
        'img': '/integrationIcon/Stamped.webp',
        'text': 'Stamped Product Reviews & UGC',
        'content': 'Stamped Reviews increases conversions with reviews & ratings, photos & videos, and Q&A.',
        'alt': 'Stamped.webp',
      },
    },
    list: [],
    isShowAllBtnLoading: true, //全局button状态
  };

  componentDidMount() {
    // 判断是否已经缓存到redux中 如果缓存了则使用缓存的值
    let _page = this.props.page.pageInit?.integration;
    if (Boolean(Object.keys(_page['getShopifyPrimary']).length)) {
      let res = _page['getShopifyPrimary'].data
      // 对应下拉选项高亮
      let obj = this.state.selectActiveObj
      // 全部不高亮
      for (let key in obj) {
        obj[key] = false
      }
      let _t = res.select_app;
      let compareType = {
        "Smartify": "LAI Product Reviews",
        "Fera": "Fera Product Reviews",
        "Areviews": "Areviewsapp - video reviews",
        "Stamped": "Stamped Product Reviews & UGC",
      }
      let selectObj = ["Smartify", "Fera", "Areviews", "Stamped"].includes(_t) ? compareType[_t] : _t;
      obj[selectObj] = true
      this.setState({
        loading: false,
        saveBtnStatus: false,
        btnText: selectObj,
        selectActiveObj: obj,
      })
    }
    this.getShopifyPrimary();
    this.changeIntegrationDataStatus();
    // let list = Object.keys(this.state.defaultData).map((item, key) => {
    //   let data = this.state.defaultData
    //   return <div key={key}>
    //     {/* <Card> */}
    //     <div className='FunctionIntegrationList'>
    //       <Thumbnail
    //         source={data[item].img}
    //         size="large"
    //         alt={data[item].alt}
    //       />
    //       <BlockStack>
    //         <div style={{ maxWidth: window.innerWidth < 500 ? '100%' : '16rem' }}>
    //           <Text variant="headingMd" as="h6">
    //             {data[item].text}
    //           </Text>
    //           <p>
    //             {data[item].content}
    //           </p>
    //         </div>
    //       </BlockStack>
    //     </div>
    //   </div>
    // })
    // this.setState({
    //   list
    // })
  }

  componentWillUnmount() {
    this.props.setResetBtnLoading('integration'); // 重置全局数据更新状态
    this.setState = () => false
  }

  // 获取缓存数据更新状态
  changeIntegrationDataStatus = () => {
    let _page = this.props.page.pageInit?.integration;
    if (_page.isResetLoading) {
      this.setState({
        isShowAllBtnLoading: false
      })
    } else {
      setTimeout(() => {
        this.changeIntegrationDataStatus();
      }, 1000)
    }
  }

  // 获取集成选择
  getShopifyPrimary = async () => {
    // 判断是否已经缓存到redux中 如果缓存了则不用loading
    let _page = this.props.page.pageInit?.integration;
    if (Boolean(Object.keys(_page['getShopifyPrimary']).length)) {
      this.setState({
        loading: false,
        loadingPage: false,
        saveBtnStatus: false
      })
    } else {
      this.setState({
        loading: true,
        saveBtnStatus: true
      })
    }
    const res = await reqGetShopifyPrimary();
    if (res.code === 200) {
      // 判断是否第一次 第一次则缓存
      this.props.getPageDataRedux({ 'getShopifyPrimary': res });
      // setTimeout(() => {
      //   console.log('integration', this.props.public);
      // }, 1000)
      // 对应下拉选项高亮
      let obj = this.state.selectActiveObj
      // 全部不高亮
      for (let key in obj) {
        obj[key] = false
      }
      let _t = res.data.select_app;
      let compareType = {
        "Smartify": "LAI Product Reviews",
        "Fera": "Fera Product Reviews",
        "Areviews": "Areviewsapp - video reviews",
        "Stamped": "Stamped Product Reviews & UGC",
      }
      let selectObj = ["Smartify", "Fera", "Areviews", "Stamped"].includes(_t) ? compareType[_t] : _t;
      obj[selectObj] = true
      this.setState({
        loading: false,
        loadingPage: false,
        saveBtnStatus: false,
        btnText: selectObj,
        selectActiveObj: obj,
      })
    } else {
      this.props.toggleToast(res.msg, true);
    }
  }

  // 设置集成选择APP
  saveShopifyPrimary = async (select_app) => {
    this.setState({
      saveBtnStatus: true
    })
    let _t = select_app;
    let compareType = {
      "LAI Product Reviews": "Smartify",
      "Fera Product Reviews": "Fera",
      "Areviewsapp - video reviews": "Areviews",
      "Stamped Product Reviews & UGC": "Stamped",
    }
    const params = {
      select_app: compareType[_t] ? compareType[_t] : _t,
    }
    const res = await resSaveShopifyPrimary(params);
    if (res.code === 200) {
      let obj = this.state.selectActiveObj
      for (let key in obj) {
        obj[key] = false
      }
      // 对应下拉选项高亮
      obj[select_app] = true
      this.props.toggleToast(res.msg, false);
      this.setState({
        saveBtnStatus: false,
        selectActiveObj: obj,
      })
    } else {
      this.props.toggleToast(res.msg, true);
      this.setState({
        saveBtnStatus: false,
      })
    }
  }

  toggleActive = (val) => {
    this.setState({
      active: !val
    })
  }

  handleClickAction = (val) => {
    let obj = this.state.selectActiveObj
    // 全部不高亮
    for (let key in obj) {
      obj[key] = false
    }
    switch (val) {
      case "Judge":
        val = "Judge Me"
        obj["Judge Me"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Trust":
        val = "TT Ali Reviews"
        obj["TT Ali Reviews"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Loox":
        val = "Loox"
        obj["Loox"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Reviews":
        val = "Shopify Product Review"
        obj["Shopify Product Review"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Ryviu":
        val = "Reviews By Ryviu"
        obj["Reviews By Ryviu"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "FireApps":
        val = "Kudosi"
        obj["FireApps Review"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Rivyo":
        val = "Rivyo"
        obj["Rivyo"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Okendo":
        val = "Okendo"
        obj["Okendo"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Smartify":
        val = "LAI Product Reviews"
        obj["LAI Product Reviews"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Fera":
        val = "Fera Product Reviews"
        obj["Fera Product Reviews"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Areviews":
        val = "Areviewsapp - video reviews"
        obj["Areviewsapp - video reviews"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      case "Stamped":
        val = "Stamped Product Reviews & UGC"
        obj["Stamped Product Reviews & UGC"] = true
        this.setState({
          selectActiveObj: obj
        })
        break;
      default:
        return ''
    }
    this.setState({
      active: false,
      btnText: val
    }, () => {
      this.saveShopifyPrimary(val);
    })
  }

  render() {
    const {
      state: {
        loading,
        active,
        btnText,
        saveBtnStatus,
        selectActiveObj,
        // list,
        isShowAllBtnLoading,
        defaultData,

      },
      toggleActive,
      handleClickAction,
    } = this;

    const activator = <Button onClick={() => toggleActive(active)} disclosure disabled={loading || saveBtnStatus || isShowAllBtnLoading}>
      {Boolean(btnText) ? <span className='pop_img'>
        <img src={defaultData[btnText === 'Kudosi' ? 'FireApps Review' : btnText].img} alt='' />
        {btnText}
      </span> : t("Not set")}
    </Button>

    const pageContent = <div>
      <Card>
        <BlockStack gap={800}>
          <div className='FuncIntegrateTop'>
            <Text variant="headingMd" as="h2">{t("Select your primary review app")}</Text>
            <p>{t("Multiple Review Apps can generate duplicate review markups, which may confuse search engines and negatively impact SEO performance. To prevent this, please set a default Review App.")}</p>
            <div className='flex_layout'>
              <label>{t("Current primary review App")}:</label>
              <Popover
                active={active}
                activator={activator}
                preferredAlignment={'left'}
                onClose={() => toggleActive(active)}
              >
                <ActionList
                  actionRole="menuitem"
                  items={[
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/JudgeMe.png' />Judge Me</span>,
                      active: selectActiveObj['Judge Me'],
                      onAction: () => handleClickAction('Judge'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/TTAliReviews.png' />TT Ali Reviews</span>,
                      active: selectActiveObj['TT Ali Reviews'],
                      onAction: () => handleClickAction('Trust'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Loox.png' />Loox</span>,
                      active: selectActiveObj['Loox'],
                      onAction: () => handleClickAction('Loox'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/ProductReview.png' />Shopify Product Review</span>,
                      active: selectActiveObj['Shopify Product Review'],
                      onAction: () => handleClickAction('Reviews'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/ReviewsRyviu.png' />Reviews By Ryviu</span>,
                      active: selectActiveObj['Reviews By Ryviu'],
                      onAction: () => handleClickAction('Ryviu'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/FireApps.png' />Kudosi</span>,
                      active: selectActiveObj['FireApps Review'],
                      onAction: () => handleClickAction('FireApps'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Rivyo.png' />Rivyo</span>,
                      active: selectActiveObj['Rivyo'],
                      onAction: () => handleClickAction('Rivyo'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Okendo.png' />Okendo</span>,
                      active: selectActiveObj['Okendo'],
                      onAction: () => handleClickAction('Okendo'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Smartify.png' />LAI Product Reviews</span>,
                      active: selectActiveObj["LAI Product Reviews"],
                      onAction: () => handleClickAction('Smartify'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Fera.jpg' />Fera Product Reviews</span>,
                      active: selectActiveObj["Fera Product Reviews"],
                      onAction: () => handleClickAction('Fera'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/areviews.jpg' />Areviewsapp - video reviews</span>,
                      active: selectActiveObj["Areviewsapp - video reviews"],
                      onAction: () => handleClickAction('Areviews'),
                    },
                    {
                      content: <span className='pop_img'><img alt='' src='/integrationIcon/Stamped.webp' />Stamped Product Reviews & UGC</span>,
                      active: selectActiveObj["Stamped Product Reviews & UGC"],
                      onAction: () => handleClickAction('Stamped'),
                    },
                  ]}
                />
              </Popover>
            </div>
            {/* <Button variant="primary" disabled={loading} loading={saveBtnStatus || isShowAllBtnLoading} onClick={() => saveShopifyPrimary(btnText)}>{t("Save")}</Button> */}
          </div>
          {/* <div className='FunctionIntegrationListAll'>
              {list}
            </div> */}
        </BlockStack>
      </Card>
    </div>

    const pageShopifyFlow = <div style={{ marginTop: "1rem" }}>
      <Card>
        <BlockStack gap={600}>
          <Text variant="headingMd" as="h2">{t("Integrate with the apps you love")}</Text>
          <div className="FunctionIntegration IntegrationLoveApp">
            <Layout>
              <Layout.Section variant='oneThird' key={0}>
                <div className='FunctionIntegrationList one_angle'>
                  <Thumbnail
                    source='/integrationIcon/shopify-flow.png'
                    size="large"
                    alt='shopify-flow.png'
                  />
                  <BlockStack gap={400}>
                    <Text variant="headingMd" as="h6">Shopify Flow</Text>
                    <p>Automate everything and get back to business</p>
                  </BlockStack>
                </div>
              </Layout.Section>
            </Layout>
            <div style={{ height: "10px" }}></div>
            <Link external url="https://www.seoant.com/blog/all/how-to-integrate-with-shopify-flow">{t("How to integrate with Shopify Flow?")}</Link>
          </div>
          <div className="FunctionIntegration IntegrationLoveApp LangwillApp">
            <Layout>
              <Layout.Section variant='oneThird' key={0}>
                <div className='FunctionIntegrationList one_angle' onClick={() => {
                  window.open("https://share.channelwill.com/app/1668099e4048633gFP")
                }}>
                  <Thumbnail
                    source='/extra_app/langwill_cw.png'
                    size="large"
                    alt='Langwill'
                  />
                  <BlockStack gap={400}>
                    <Text variant="headingMd" as="h6">Langwill: AI Language Translate</Text>
                    <p>Translate your store to improve multilingual SEO and reach global markets.</p>
                  </BlockStack>
                </div>
              </Layout.Section>
            </Layout>
            <div style={{ height: "10px" }}></div>
            <Link external url="https://support.langwill.com/article/wquery/how-is-langwill-optimized-for-multilingual-seo/article_id-pjcxbwcs-288076#articleId288076">{t("How to optimize multilingual SEO with Langwill?")}</Link>
          </div>
        </BlockStack>
      </Card>
    </div>

    // 骨架屏
    const SkeltonLoading = <div>
      <div className="Service_Layout_Card" style={{ marginTop: "0" }}>
        <Card>
          <BlockStack gap={400}>
            <SkeletonDisplayText size="small" />
            <SkeletonBodyText />
            <SkeletonBodyText />
          </BlockStack>
        </Card>
      </div>
      <div className="Service_Layout_Card" style={{ marginTop: "1rem" }}>
        <Card>
          <SkeletonDisplayText size="small" />
          <br />
          <Layout>
            <Layout.Section>
              <Card>
                <BlockStack gap={500}>
                  <SkeletonDisplayText size="small" />
                  <SkeletonBodyText />
                </BlockStack>
              </Card>
            </Layout.Section>
          </Layout>
        </Card>
      </div>
    </div>

    // 底部
    // const FooterHelpBox = <FooterTrustHelp />

    // 最终内容
    var pageContentLast = this.state.loadingPage ? SkeltonLoading :
      <div>
        {/* 内容 */}
        {pageContent}

        {pageShopifyFlow}

        {/* 底部 */}
        {/* {FooterHelpBox} */}
      </div>

    return (
      <div className="FunctionIntegration">
        {pageContentLast}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return state
}
const mapDispatchToProps = dispatch => ({
  // 判断是否页面第一次loading
  getPageDataRedux(data) {
    dispatch(setPageData(['integration', data]));
  },

  // 未更新最新数据loading
  setResetBtnLoading(page) {
    dispatch(setPageLoading([page]))
  }
})

FunctionIntegration = connect(
  mapStateToProps,
  mapDispatchToProps
)(FunctionIntegration);

export default withRouter(FunctionIntegration);
